export default function WarningSignsSection() {
  const warningSigns = [
    {
      icon: 'ri-mail-fill',
      title: 'Late Payment Notices',
      description: 'Receiving letters from your lender about missed or late mortgage payments is the first warning sign. Don\'t ignore these notices - they\'re your opportunity to avoid foreclosure before it escalates.'
    },
    {
      icon: 'ri-phone-fill',
      title: 'Collection Calls',
      description: 'Your lender or loan servicer is calling frequently about overdue payments. These calls will become more urgent as you fall further behind, and eventually, they\'ll move to foreclosure proceedings.'
    },
    {
      icon: 'ri-file-warning-fill',
      title: 'Notice of Default',
      description: 'This formal notice means you\'re officially in default on your mortgage. In Texas, you typically receive this after 120 days of missed payments. Time to avoid foreclosure is running out.'
    },
    {
      icon: 'ri-auction-fill',
      title: 'Notice of Trustee Sale',
      description: 'This notice means your home has been scheduled for foreclosure sale. You have 21 days from this notice to avoid foreclosure by paying the full amount owed or selling your property.'
    },
    {
      icon: 'ri-bank-fill',
      title: 'Difficulty Making Payments',
      description: 'Struggling to make monthly mortgage payments due to job loss, medical bills, divorce, or other financial hardships. Acting now can help you avoid foreclosure and protect your credit.'
    },
    {
      icon: 'ri-home-heart-fill',
      title: 'Underwater Mortgage',
      description: 'Owing more on your mortgage than your home is worth makes it difficult to sell traditionally. We buy foreclosed properties regardless of equity, helping you avoid foreclosure and move forward.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-red-100 text-red-800 px-4 py-2 rounded-full text-sm font-bold mb-6">
            Warning Signs You Need to Act Now
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            Are You at Risk of Foreclosure?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Recognizing the warning signs early gives you more options to avoid foreclosure. If you're experiencing any of these situations, contact us immediately for a fast cash offer on your El Paso home.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {warningSigns.map((sign, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-xl transition-shadow border-2 border-transparent hover:border-teal-600">
              <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${sign.icon} text-3xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{sign.title}</h3>
              <p className="text-base text-gray-700 leading-relaxed">{sign.description}</p>
            </div>
          ))}
        </div>

        <div className="relative rounded-2xl overflow-hidden">
          <img 
            src="https://public.readdy.ai/ai/img_res/b24808892b3b21a021db440e468ac9da.jpg" 
            alt="Warning signs of foreclosure in El Paso" 
            className="w-full h-auto"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/40 flex items-center">
            <div className="max-w-2xl mx-auto px-8 text-center">
              <h3 className="text-3xl md:text-4xl font-black text-white mb-6">
                Don't Wait Until It's Too Late
              </h3>
              <p className="text-lg text-gray-200 mb-8 leading-relaxed">
                The sooner you act, the more options you have to avoid foreclosure. We can make you a cash offer within 24 hours and close before your foreclosure sale date.
              </p>
              <a 
                href="tel:+1-915-206-5814" 
                className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-10 py-4 rounded-lg text-lg font-bold transition-all shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call (915) 206-5814 Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}